<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Issue Date"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker v-model="issueDate" :rules="rules.issueDateRules"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="orderPO.warehouseId"
                  :items="activeWarehouseList"
                  color="blue-grey lighten-2"
                  label="Choose Warehouse..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :readonly="user.role.roleName == 'WAREHOUSE_MANAGER' || user.role.roleName == 'SALE_MANAGER' || user.role.roleName == 'GENERAL_MANAGER'"
                  :rules="rules.warehouseRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="orderPO.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.currencyRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-combobox
                  item-text="orderNo"
                  item-value="id"
                  label="Choose Order No"
                  multiple
                  @click.stop="openOrderDialog()"
                  v-model="selectedOrder"
                  :rules="rules.orderRules"
                ></v-combobox>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="orderPO.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 ml-2 mt-1>
                <v-switch
                  v-model="isItemDiscount"
                  inset
                  :label="'discount'"
                  @change="toggleDiscount"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <!-- No Supplier Section -->
      <v-layout row wrap>
        <v-flex>
          <v-card>
            <v-card-title primary-title>
              <div>
                <div class="title">No Supplier Products</div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap class="light--text">
                <v-flex xs12 sm1>Code</v-flex>
                <v-flex xs12 sm2>Product</v-flex>
                <v-flex xs12 sm1>Unit</v-flex>
                <v-flex xs12 sm1>Qty</v-flex>
                <v-flex xs12 sm1>Confirm Qty</v-flex>
                <v-flex xs12 sm1>Unit Cost</v-flex>
                <v-flex xs12 sm1 v-if="isItemDiscount">Unit Cost %</v-flex>
                <v-flex xs12 sm1>Total Amount</v-flex>
                <v-flex xs12 sm2>Supplier</v-flex>
                <v-flex xs12 sm1>Action</v-flex>
                <v-divider></v-divider>
                <v-flex v-for="(item, index) in this.orderPO.purchaseOrderOrderItems" :key="index">
                  <v-layout row class="white" v-if="item.productDTO.supplierList.length == 0">
                    <v-flex xs12 sm1>
                      <v-text-field v-model="item.productDTO.code" label="Code" :readonly="true"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm2>
                      <v-text-field v-model="item.productName" label="Product" :readonly="true"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-autocomplete
                        v-model="item.factorUnitName"
                        :hide-no-data="true"
                        :items="item.productUnits"
                        color="blue-grey lighten-2"
                        item-value="factorUnitName"
                        item-text="factorUnitName"
                        menu-props="auto"
                        label="Select"
                        @change="option => initPrice(option,index)"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-text-field
                        v-model="item.qty"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        :rules="rules.qtyRules"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-text-field
                        v-model="item.orderQty"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        :rules="rules.qtyRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-text-field
                        v-model="item.actualUnitCost"
                        type="number"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm1 v-if="isItemDiscount">
                      <v-text-field
                        v-model="item.discountPercent"
                        type="number"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm1
                      pt-4
                    >{{item.orderQty * item.unitCost | decFormat(6)}}</v-flex>
                    <v-flex xs12 sm2>
                      <a @click="goToSupplier">Create Supplier</a>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-btn icon @click="removePurchaseOrderItem(index)">
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <!-- Multiple Supplier Section -->
      <v-layout row wrap>
        <v-flex>
          <v-card>
            <v-card-title primary-title>
              <div>
                <div class="title">Multiple Supplier Products</div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap class="light--text">
                <v-flex xs12 sm1>Code</v-flex>
                <v-flex xs12 sm2>Product</v-flex>
                <v-flex xs12 sm1>Unit</v-flex>
                <v-flex xs12 sm1>Qty</v-flex>
                <v-flex xs12 sm1>Confirm Qty</v-flex>
                <v-flex xs12 sm1>Unit Cost</v-flex>
                <v-flex xs12 sm1 v-if="isItemDiscount">Unit Cost %</v-flex>
                <v-flex xs12 sm1>Total Amount</v-flex>
                <v-flex xs12 sm2>Supplier</v-flex>
                <v-flex xs12 sm1>Action</v-flex>
                <v-divider></v-divider>
                <v-flex v-for="(item, index) in this.orderPO.purchaseOrderOrderItems" :key="index">
                  <v-layout row class="white" v-if="item.productDTO.supplierList.length > 1">
                    <v-flex xs12 sm1>
                      <v-text-field v-model="item.productDTO.code" label="Code" :readonly="true"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm2>
                      <v-text-field v-model="item.productName" label="Product" :readonly="true"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-autocomplete
                        v-model="item.factorUnitName"
                        :hide-no-data="true"
                        :items="item.productUnits"
                        color="blue-grey lighten-2"
                        item-value="factorUnitName"
                        item-text="factorUnitName"
                        menu-props="auto"
                        label="Select"
                        @change="option => initPrice(option,index)"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-text-field
                        v-model="item.qty"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        :rules="rules.qtyRules"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-text-field
                        v-model="item.orderQty"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        :rules="rules.qtyRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-text-field
                        v-model="item.actualUnitCost"
                        type="number"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm1 v-if="isItemDiscount">
                      <v-text-field
                        v-model="item.discountPercent"
                        type="number"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm1
                      pt-4
                    >{{item.orderQty * item.unitCost | decFormat(6)}}</v-flex>
                    <v-flex xs12 sm2>
                      <v-autocomplete
                        v-model="item.supplierId"
                        :items="item.productDTO.supplierList"
                        color="blue-grey lighten-2"
                        label="Choose Supplier..."
                        item-text="companyName"
                        menu-props="auto"
                        item-value="id"
                        :rules="rules.supplierRules"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-btn icon @click="removePurchaseOrderItem(index)">
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <!-- Multiple Supplier Section -->
      <v-layout row wrap>
        <v-flex>
          <v-card>
            <v-card-title primary-title>
              <div>
                <div class="title">Confirmed Supplier Products</div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap class="light--text">
                <v-flex sm1>Code</v-flex>
                <v-flex sm2>Product</v-flex>
                <v-flex sm1>Unit</v-flex>
                <v-flex sm1>Qty</v-flex>
                <v-flex sm1>Confirm Qty</v-flex>
                <v-flex sm1>Unit Cost</v-flex>
                <v-flex sm1 v-if="isItemDiscount">Unit Cost %</v-flex>
                <v-flex sm1>Total Amount</v-flex>
                <v-flex sm2>Supplier</v-flex>
                <v-flex sm1>Action</v-flex>
                <v-divider></v-divider>
                <v-flex v-for="(item, index) in this.orderPO.purchaseOrderOrderItems" :key="index">
                  <v-layout row class="white" v-if="item.productDTO.supplierList.length == 1">
                    <v-flex sm1>
                      <v-text-field v-model="item.productDTO.code" label="Code" :readonly="true"></v-text-field>
                    </v-flex>
                    <v-flex sm2>
                      <v-text-field v-model="item.productName" label="Product" :readonly="true"></v-text-field>
                    </v-flex>
                    <v-flex sm1>
                      <v-autocomplete
                        v-model="item.factorUnitName"
                        :hide-no-data="true"
                        :items="item.productUnits"
                        color="blue-grey lighten-2"
                        item-value="factorUnitName"
                        item-text="factorUnitName"
                        menu-props="auto"
                        label="Select"
                        @change="option => initPrice(option,index)"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex sm1>
                      <v-text-field
                        v-model="item.qty"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        :rules="rules.qtyRules"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm1>
                      <v-text-field
                        v-model="item.orderQty"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        :rules="rules.qtyRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm1>
                      <v-text-field
                        v-model="item.actualUnitCost"
                        type="number"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm1 v-if="isItemDiscount">
                      <v-text-field
                        v-model="item.discountPercent"
                        type="number"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      sm1
                      pt-4
                    >{{item.orderQty * item.unitCost | decFormat(6)}}</v-flex>
                    <v-flex sm2>
                      <v-autocomplete
                        v-model="item.supplierId"
                        :items="item.productDTO.supplierList"
                        color="blue-grey lighten-2"
                        label="Choose Supplier..."
                        item-text="companyName"
                        menu-props="auto"
                        item-value="id"
                        readonly
                        :rules="rules.supplierRules"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex sm1>
                      <v-btn icon @click="removePurchaseOrderItem(index)">
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex>
          <v-card>
            <v-flex sm12>
              <div class="text-xs-center">
                <v-btn color="error" @click="clear">
                  Reset
                  <v-icon right>clear</v-icon>
                </v-btn>
                <v-btn color="primary" :loading="saveLoading" :readonly="!valid" type="submit">
                  Save
                  <v-icon right>save</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Order list dialog -->
    <v-dialog v-model="showOrderListDialog" scrollable max-width="1000px" persistent>
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="orderQueryParams.fromOrderDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="orderQueryParams.fromOrderDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3 pl-1>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="orderQueryParams.toOrderDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="orderQueryParams.toOrderDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3 pl-1>
              <v-text-field
                name="orderNo"
                label="Order No"
                type="text"
                v-model="orderQueryParams.orderNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3 pl-1 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'PROCUREMENT_MANAGER'">
              <v-autocomplete
                v-model="orderQueryParams.shopId"
                :items="shopList"
                color="blue-grey lighten-2"
                label="Shop"
                item-text="name"
                menu-props="auto"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="orderOnSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-card>
              <v-data-table
                v-model="selectedOrder"
                :headers="orderHeaders"
                :items="orderList"
                class="elevation-1"
                :loading="showOrderListLoading"
                :total-items="orderTotalRows"
                :rows-per-page-items="orderRowsPerPageItems"
                :pagination.sync="orderPagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <tr :active="props.selected" @click="props.selected = !props.selected">
                    <td>
                      <v-checkbox primary hide-details :input-value="props.selected"></v-checkbox>
                    </td>
                    <td>{{ props.item.orderDateInMilliSeconds | format-ms-date-time }}</td>
                    <td>{{ props.item.orderNo }}</td>
                    <td>{{ props.item.estimateDeliveryDateInMilliSeconds | format-ms-date-time }}</td>
                    <td>{{ props.item.csRequestDateInMilliSeconds | format-ms-date-time }}</td>
                    <td>{{ props.item.customerDTO.name }}</td>
                    <td>{{ props.item.phoneNo}}</td>
                    <td>{{ props.item.cityDTO.name }}</td>
                    <td>{{ props.item.townshipDTO.name }}</td>
                    <td>{{ props.item.userDTO.username }}</td>
                  </tr>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="done">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { orderPOFormRules } from "../../helpers/validation-rules";
import { PurchaseOrderOrder, PurchaseOrderOrderItem } from "../../models/model";
import { warehouseService } from "../../services/warehouse-service";
import { currencyService } from "../../services/currency-service";
import { orderService } from "../../services/order-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { purchaseOrderService } from "../../services/purchase-order-service";
import { shopService } from "../../services/shop-service";

export default {
  name: "PurchaseOrderOrder",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    checkbox: false,
    breadcrumbs: [
      {
        text: "Purchase Order",
        disabled: false,
        to: "purchase-order",
      },
      {
        text: "Order PO",
        disabled: true,
      },
    ],
    responseError: "",
    rules: new orderPOFormRules(),
    issueDate: new Date().toISOString().substr(0, 10),
    orderPO: new PurchaseOrderOrder(),
    orderPOItem: new PurchaseOrderOrderItem(),
    activeWarehouseList: [],
    currencyList: [],
    orderQueryParams: {
      fromOrderDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toOrderDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      orderNo: "",
      poFlag: "False",
      status: "CONFIRM",
      wholesaleFlag: "False",
      shopId: "",
    },
    shopList: [],
    showOrderListLoading: false,
    orderPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    orderList: [],
    orderTotalRows: 0,
    showOrderListDialog: false,
    orderHeaders: [
      { text: "", value: "", sortable: false },
      { text: "Order Date", value: "orderDate" },
      { text: "Order No", align: "left", value: "orderNo" },
      { text: "Est. Delivery Date", value: "estDate" },
      { text: "Customer Request Date", value: "csRequestDate" },
      { text: "Customer Name", value: "customerDTO.name" },
      { text: "Phone No", value: "phoneNo", sortable: false },
      { text: "City", value: "cityDTO.name" },
      { text: "Township", value: "townshipDTO.name" },
      { text: "Order Person", value: "userDTO.username" },
    ],
    orderRowsPerPageItems: [25, 50, 100],
    selected: [],
    isItemDiscount: true,
    selectedOrder: [],
    decimalFormat: "",
    saveLoading: false,
  }),
  watch: {
    orderPagination: {
      handler() {
        this.getOrderList();
      },
      deep: true,
    },
  },
  created() {
    this.decimalFormat = commonService.formatdecimal();
    this.getActiveWarehouseList();
    this.getShopList();
    this.getCurrencyList();
    if (this.user.roleName == "WAREHOUSE_MANAGER") {
      this.orderPO.warehouseId = this.user.warehouseId;
    }
    if (this.user.roleName == "SALE_MANAGER" || this.user.roleName == "GENERAL_MANAGER") {
      this.orderPO.warehouseId = this.user.shop.warehouseId;
      this.orderQueryParams.shopId = this.user.shop.id;
    }
    this.toggleDiscount();
  },
  methods: {
    goBack() {
      this.$router.push("/purchase-order");
    },
    getActiveWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.activeWarehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCurrencyList() {
      currencyService
        .getAllCurrency()
        .then((res) => {
          this.currencyList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openOrderDialog() {
      // Clean query params
      this.orderQueryParams.orderNo = "";

      this.getOrderList().then(
        (this.showOrderListDialog = !this.showOrderListDialog)
      );
    },
    getOrderList() {
      this.showOrderListLoading = true;
      let order = this.orderPagination.descending ? "desc" : "asc";
      return orderService
        .getOrderList(
          this.orderQueryParams,
          this.orderPagination.page,
          this.orderPagination.rowsPerPage,
          this.orderPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.orderList = res.data.orderHeaderList;
            this.orderTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.showOrderListLoading = false;
        });
    },
    orderOnSearch() {
      this.orderQueryParams.page = this.orderPagination.page;
      this.orderQueryParams.size = this.orderPagination.rowsPerPage;
      this.getOrderList();
    },
    done() {
      this.showOrderListDialog = !this.showOrderListDialog;
      this.orderPO.orderIds = [];
      this.orderPO.purchaseOrderOrderItems = [];
      for (let item of this.selectedOrder) {
        this.orderPO.orderIds.push(item.id);
        for (let itemDetail of item.orderHeadDetails) {
          if (this.isItemExist(itemDetail)) {
            this.orderPO.purchaseOrderOrderItems.forEach(function (item) {
              if (item.productId === itemDetail.productId && item.factorUnitName === itemDetail.factorUnitName) {
                item.orderQty =
                  Math.abs(item.orderQty) + Math.abs(itemDetail.confirmQty);
                item.qty =
                  Math.abs(item.orderQty) + Math.abs(itemDetail.confirmQty);
              }
              item.qty = item.orderQty;
            });
          } else {
            itemDetail.qty = itemDetail.confirmQty;
            itemDetail.orderQty = itemDetail.confirmQty;
            this.orderPO.purchaseOrderOrderItems.push(itemDetail);
          }
          let discountFlag = this.isItemDiscount;
          this.orderPO.purchaseOrderOrderItems.forEach(function (item) {
            if (item.productId === itemDetail.productId && item.factorUnitName === itemDetail.factorUnitName) {
              item.discountPercent =
                itemDetail.productUnitDTO.unitCostPercentage;
              item.actualUnitCost = itemDetail.productUnitDTO.unitCost;
              item.sellingPrice = itemDetail.productUnitDTO.sellingPrice;
              if (discountFlag) {
                let discount =
                  itemDetail.productUnitDTO.unitCost *
                  (itemDetail.productUnitDTO.unitCostPercentage / 100);
                discount = parseFloat(discount).toFixed(6);
                item.unitCost = parseFloat(
                  itemDetail.productUnitDTO.unitCost - discount
                ).toFixed(6);
              } else {
                item.unitCost = itemDetail.productUnitDTO.unitCost;
              }
            }
            if (item.productDTO.supplierList.length == 1) {
              item.supplierId = item.productDTO.supplierList[0].id;
            }
          });
        }
      }
    },
    toggleDiscount() {
      if (this.isItemDiscount) {
        this.orderPO.purchaseOrderOrderItems.forEach((element) => {
          let discount = element.unitCost * (element.discountPercent / 100);
          discount = parseFloat(discount).toFixed(6);
          element.unitCost = parseFloat(element.unitCost - discount).toFixed(6);
        });
        this.orderPO.isItemDiscount = true;
      } else {
        this.orderPO.purchaseOrderOrderItems.forEach((element) => {
          element.unitCost = element.actualUnitCost;
        });
        this.orderPO.isItemDiscount = false;
      }
    },
    initPrice(factorUnitName, index) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.orderPO.purchaseOrderOrderItems[index].productUnits
      );

      if (this.isItemDiscount) {
        let discount =
          productUnit.unitCost * (productUnit.unitCostPercentage / 100);
        discount = parseFloat(discount).toFixed(6);
        this.orderPO.purchaseOrderOrderItems[index].unitCost = parseFloat(
          productUnit.unitCost - discount
        ).toFixed(6);
      } else {
        this.orderPO.purchaseOrderOrderItems[index].unitCost =
          productUnit.unitCost;
      }
      this.orderPO.purchaseOrderOrderItems[index].productUnitId =
        productUnit.id;
      this.orderPO.purchaseOrderOrderItems[index].actualUnitCost =
        productUnit.unitCost;
      this.orderPO.purchaseOrderOrderItems[index].sellingPrice =
        productUnit.sellingPrice;
      this.orderPO.purchaseOrderOrderItems[index].discountPercent =
        productUnit.unitCostPercentage;
    },
    isItemExist(orderDetail) {
      for (let item of this.orderPO.purchaseOrderOrderItems) {
        if (
          item.productId === orderDetail.productId &&
          item.factorUnitName === orderDetail.factorUnitName
        ) {
          return true;
        }
      }
    },
    removePurchaseOrderItem(index) {
      this.$delete(this.orderPO.purchaseOrderOrderItems, index);
    },
    goToSupplier() {
      this.$router.push("/suppliers");
    },
    clear() {
      this.$refs.form.resetValidation();
      this.orderPO = new PurchaseOrderOrder();
      this.selectedOrder = [];
      if (this.user.roleName == "WAREHOUSE_MANAGER") {
        this.orderPO.warehouseId = this.user.warehouseId;
      }
      this.issueDate = new Date().toISOString().substr(0, 10);
      this.isItemDiscount = false;
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.orderPO.isItemDiscount = this.isItemDiscount;
        //convert to millisecond
        this.orderPO.issueDateInMilliSeconds = commonService.convertToMilliseconds(
          this.issueDate
        );
        purchaseOrderService
          .saveOrderPO(this.orderPO)
          .then((res) => {
            if (res) {
              this.goBack();
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
  },
};
</script>